module.exports = __webpack_public_path__ + "static/media/mshtml_32545.f62900f9.ico";